import React from 'react';

import { LECTURE_TYPES } from '@classCreation/data/lectureTypes';
import Select from 'components/Select';

const SELECT_OPTIONS = Object.values(LECTURE_TYPES).map((lectureType) => ({
  label: lectureType,
  value: lectureType,
}));

export default function LectureTypeSelect(props) {
  return (
    <Select
      options={SELECT_OPTIONS}
      placeholder="Select Lecture Type"
      {...props}
    />
  );
}
